import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectPerPayPeriodText } from 'enrollment/services';
import {
  RiderTotalCostContainerStyled,
  TotalCostCostStyled,
  TotalCostTextStyled,
} from './RiderBenefitsStyled';
import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';

interface TotalCostBannerProps {
  cost: number;
  hideEmptyCost: boolean;
}

export const TotalCostBanner = ({
  cost,
  hideEmptyCost,
}: TotalCostBannerProps) => {
  const { t } = useTranslation('common');

  const perPayText = useSelector(selectPerPayPeriodText);

  return !hideEmptyCost || cost > 0 ? (
    <RiderTotalCostContainerStyled data-testid="total-cost-container">
      <TotalCostTextStyled>
        {t('enrollment.totalCost')}
        {perPayText}
      </TotalCostTextStyled>
      <TotalCostCostStyled>
        {getPremiumStyled({
          premium: String(cost),
          valueOnly: RETURN_VALUE_ONLY,
        })}
      </TotalCostCostStyled>
    </RiderTotalCostContainerStyled>
  ) : (
    <></>
  );
};
